/* Theme utilities - a11y fixes and scroll-to-top */
(function(){
  /* A11y fixes for third-party widgets. Per-element `data-a11y-fixed` flag
     prevents wasted work on repeat passes. A MutationObserver picks up
     widgets injected after DOMContentLoaded (chat, merchant iframe). */
  function fixA11y(){
    document.querySelectorAll('button.chat-toggle,.chat-app .chat-toggle').forEach(function(b){
      if(b.dataset.a11yFixed)return;
      b.dataset.a11yFixed='1';
      if(!b.getAttribute('aria-label'))b.setAttribute('aria-label','Talk to an Engineer');
    });
    document.querySelectorAll('#ShopifyChat,inbox-online-store-chat').forEach(function(host){
      if(!host.getAttribute('aria-label'))host.setAttribute('aria-label','Talk to an Engineer');
      if(!host.getAttribute('title'))host.setAttribute('title','Talk to an Engineer');
      var root=host.shadowRoot;
      if(!root)return;
      root.querySelectorAll('button,[role="button"]').forEach(function(button){
        if(!button.getAttribute('aria-label')&&!String(button.textContent||'').trim()){
          button.setAttribute('aria-label','Talk to an Engineer');
        }
      });
    });
    const f=document.getElementById('merchantwidgetiframe');
    if(f&&!f.dataset.a11yFixed){
      f.dataset.a11yFixed='1';
      if(!f.title)f.title='Google Customer Reviews';
    }
  }
  function initA11y(){
    fixA11y();
    if(typeof MutationObserver==='undefined')return;
    let queued=false;
    const mo=new MutationObserver(function(){
      if(queued)return;
      queued=true;
      requestAnimationFrame(function(){queued=false;fixA11y();});
    });
    mo.observe(document.body,{childList:true,subtree:true});
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',initA11y);
  }else{
    initA11y();
  }

  /* Scroll-to-top visibility + click handler */
  const btn=document.querySelector('.scroll-to-top');
  if(btn){
    btn.addEventListener('click',function(){window.scrollTo({top:0,behavior:'smooth'})});
    let ticking=false;
    window.addEventListener('scroll',function(){
      if(!ticking){
        requestAnimationFrame(function(){
          btn.classList.toggle('visible',window.scrollY>400);
          ticking=false;
        });
        ticking=true;
      }
    },{passive:true});
  }
  document.querySelectorAll('.counter-animate').forEach(function(c){
    const target=parseInt(c.dataset.target,10);
    if(Number.isFinite(target))c.textContent=String(target);
  });
})();
